import * as React from 'react'

import { Alert, Box, Button, Text } from '@factorialco/deprecated-design-system'
import { F0Alert, F0Box, F0Dialog, F0Text } from '@factorialco/f0-react'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  totalDocuments?: number
  filename?: string
  hasSignature?: boolean
  loading: boolean
  onSubmit: () => void
  onClose: () => void
  useF0?: boolean
}

const TrashBinModal = ({
  totalDocuments = 1,
  filename,
  hasSignature = false,
  loading,
  onSubmit,
  onClose,
  useF0 = false,
}: Props) => {
  const isDisabled = loading

  if (useF0) {
    return (
      <F0Dialog
        isOpen
        width="sm"
        title={i18n.t('documents.move_to_trash_bin_modal.title')}
        onClose={onClose}
        primaryAction={{
          label: i18n.t('documents.move'),
          onClick: onSubmit,
          disabled: isDisabled,
          loading,
          variant: 'danger',
        }}
        secondaryAction={{
          label: i18n.t('common.cancel'),
          onClick: onClose,
        }}
      >
        <F0Box display="flex" flexDirection="column" gap="xl">
          <F0Text
            variant="body"
            content={i18n.tp('documents.move_to_trash_bin_modal.description', {
              name: filename,
              count: totalDocuments,
            })}
          />
          {hasSignature && (
            <F0Alert
              variant="warning"
              title={i18n.tp('documents.move_to_trash_bin_modal.alert', { count: totalDocuments })}
              description=""
            />
          )}
        </F0Box>
      </F0Dialog>
    )
  }

  return (
    <Modal
      title={i18n.t('documents.move_to_trash_bin_modal.title')}
      illustration="delete"
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button
            iconName={loading ? 'delete' : undefined}
            type="negative"
            disabled={isDisabled}
            loading={loading}
            submit
          >
            {i18n.t('documents.move')}
          </Button>
        </>
      }
    >
      <Box gap="s16">
        <Text.Normal>
          {i18n.tp('documents.move_to_trash_bin_modal.description', {
            name: filename,
            count: totalDocuments,
          })}
        </Text.Normal>

        {hasSignature && (
          <Alert color="warning">
            {i18n.tp('documents.move_to_trash_bin_modal.alert', { count: totalDocuments })}
          </Alert>
        )}
      </Box>
    </Modal>
  )
}

export default observer(TrashBinModal)
